export const PagePaths = {
  root: '/',

  settings: '/settings',

  signUp: '/signup',
  forgotPassword: '/forgot-password',
  createEntity: '/create-entity',
  createEntityId: '/create-entity/:id',
  createEntityAccount: '/entity-account',

  setupFund: '/setup-fund',
  setupFundId: '/setup-fund/:id',
  setupFundIdEdit: '/setup-fund/edit/:id',
  setupFundReview: '/setup-fund/review/:id',
  fundDashboard: '/fund-dashboard',
  fundDashboardId: '/fund-dashboard/:id',
  manageEntity: '/manage-entity',
  manageEntityId: '/manage-entity/:id',
  manageEntityReview: '/manage-entity/review/:id',
  manageTeam: '/manage-team',
  manageTeamEntityId: '/manage-team/entity/:id',
  gammaRoles: '/gamma-roles',
  manageFunds: '/manage-funds',

  investors: '/investors',

  allFunds: '/all-funds',
  allFundsId: '/all-funds/:identifier',
  // Master-feeder share URL, e.g. /all-funds/master-feeder-test/us-feeder.
  allFundsFeeder: '/all-funds/:identifier/:feederFund',
  // Investing wizard, e.g. /all-funds/harbor-credit-fund/invest?investmentId=investment-xyz.
  allFundsInvest: '/all-funds/:identifier/invest',

  overview: '/overview',
  overviewEntity: '/overview/entity/:id',
  overviewFund: '/overview/fund/:id',

  portfolio: '/portfolio',
  portfolioSend: '/portfolio/send',
  portfolioReceive: '/portfolio/receive',

  events: '/events',
  // Declared before `eventsId` so the static segment is not captured by the `:id` param route.
  eventsManaging: '/events/managing',
  eventsCreate: '/events/create',
  eventsCreateId: '/events/create/:id',
  eventsId: '/events/:id',
  /** Public, shell-less event page; reachable signed out. */
  publicEvent: '/e/:slug',
  getApp: '/app',

  questionnaire: '/questionnaire',

  communications: '/communications',
  communicationsV2: '/communications-v2',
  chatExternalLink: '/communications/leaving',
  introducer: '/introducer',
  introducerHowToEarn: '/introducer/how-to-earn',
  introducerUser: '/introducer/:id',

  devIcons: '/dev/icons',

  kycComplete: '/kyc/complete',

  gammaTeamManagement: '/gamma-team-management',
  investmentPipeline: '/investment-pipeline',
  investingBoard: '/investing-board',

  deals: '/deals',
  dealsKanban: '/deals-kanban',
  dealsPipeline: '/deals-pipeline',
  dealsOfferView: '/deals/offers/:companyId/:offerId',
  dealsCompanyProfile: '/deals/:id',
  dealsCreateCompany: '/deals/create-company',
  dealsEditCompany: '/deals/edit-company/:companyId',
  dealsPostOffer: '/deals/post-offer',

  addressBook: '/address-book',
  addressBookContact: '/address-book/contact/:id',
  addressBookEntity: '/address-book/entity/:id',
  addressBookCategories: '/address-book/categories',
  addressBookCategory: '/address-book/categories/:id',
  addressBookImportCallback: '/address-book/import/callback',
  contactImportCallback: '/contact-import/callback',

  userProfile: '/user/:id',
  subscriptions: '/subscriptions',

  // Personal QR connect link (GP-3960) — {origin}/q/{token}, scanned by a phone's own camera.
  // Reachable signed-in or signed-out; see `pages/q/_token` and `routes/data.tsx`.
  qrConnect: '/q/:token',
} as const;
